import { baseAPIClient, baseAPIClientAnonymous } from 'domains/api/base/baseAPI';
import { anonymousExternalAPIClient } from 'domains/api/base/external';
import { proxyAPIClient } from 'domains/api/proxy/proxyAPI';
import { schedulingAPIClient } from 'domains/api/scheduling/schedulingAPI';

export const api = {
  /** New post-migration portal API  */
  base: baseAPIClient,
  /** New post-migration portal API for anonymous endpoints without cognito authentication  */
  baseAnonymous: baseAPIClientAnonymous,
  /** Proxy API */
  proxy: proxyAPIClient,
  /** Scheduling API */
  scheduling: schedulingAPIClient,

  external: anonymousExternalAPIClient,
};
